// extracted by mini-css-extract-plugin
export default {"container":"Foundation_container__YDO8T","label":"Foundation_label__5LtpE","active":"Foundation_active__Bhsey"};